import DualDropOnePinModal from '@wt/game/modals/HintWallet/DualDropOnePinModal';
import { useHints } from '@wt/game/providers/hints/HintsProvider';
import { getSiteMode } from '@wt/utilities/siteMode';
import { useState } from 'react';
import { toast } from 'react-toastify';

export const GuessButton = ({
  yearSelected,
  locationSelected,
  secondaryLocationSelected,
  onClick,
}: {
  yearSelected: boolean;
  locationSelected: boolean;
  secondaryLocationSelected: boolean;
  onClick: () => void;
}) => {
  const [dualDropModalOpen, setDualDropModalOpen] = useState(false);
  const hints = useHints();

  const colorClasses =
    (!yearSelected && getSiteMode() != 'wheretaken') || !locationSelected
      ? 'bg-muted hover:bg-muted movies:hover:text-[#2E2C26] movies:text-[#2E2C26] text-white/90 hover:text-white/90 border-none'
      : '';

  const yearRequired = getSiteMode() != 'wheretaken';
  const handleClick = () => {
    if (yearRequired && !yearSelected && !locationSelected) {
      toast.error('Please choose a year and a location.', {
        position: 'bottom-center',
      });
    } else if (yearRequired && !yearSelected) {
      toast.error('Move the slider to select a year or type in your answer.', {
        position: 'bottom-center',
      });
    } else if (!locationSelected) {
      toast.error('Click anywhere on the map to place the pin.', {
        position: 'bottom-center',
      });
    } else if (hints.hasUsedHint('dualdrop') && !secondaryLocationSelected) {
      setDualDropModalOpen(true);
    } else {
      onClick();
    }
  };

  return (
    <>
      {dualDropModalOpen && (
        <DualDropOnePinModal
          closeModal={() => {
            setDualDropModalOpen(false);
          }}
          handleClickConfirm={() => {
            setDualDropModalOpen(false);
            onClick();
          }}
        />
      )}
      <button
        type="button"
        onClick={handleClick}
        className={`btn btn-primary w-full shrink text-lg font-bold uppercase ${colorClasses} md:h-[61px] lg:text-2xl`}
      >
        Guess
      </button>
    </>
  );
};
